import React, {useState, useId} from "react";

function Facet({heading, facets, onFacetChange, expanded}) {
  const [isHidden, setIsHidden] = useState(!expanded);
  const facetId = useId();
  function renderFacets() {
    return facets.map((facet) => {
      return (
        <div key={facet.id} className='facet fs-sm'>
          <div className='facet__input'>
            <input checked={facet.checked} onChange={onFacetChange} data-filter={facet.value} name={facet.id} type='checkbox' id={facet.id} value={facet.label} />
            <label htmlFor={facet.id}> {facet.label} </label>
          </div>
          <div className='facet__count'>
            <span> {facet.count} </span>
          </div>
        </div>
      );
    });
  }

  return(
    <div className="facet-wrapper surface--light-lightest-cream">
      <div className='facet-wrapper__heading'>
        <h4
          aria-controls={facetId}
          tabIndex='-1'
          className={`facet-wrapper__trigger ${!isHidden ? 'active' : ''}`}
          onClick={() => setIsHidden(!isHidden)}>
            {heading}
          </h4>
      </div>
      <fieldset aria-hidden={isHidden} id={facetId} className="facet-wrapper__panel">
        {renderFacets()}
      </fieldset>
    </div>
  );
}

export default Facet;
